import * as React from 'react'
import { UserInvitesMainConnected } from './UserInvitesMainConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const UserInvitesMainExamples = () => {
  return (
    <div className="UserInvitesMainExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <UserInvitesMainConnected />
      </Provider>
    </div>
  )
}
